import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../../context/Auth/AuthContext";

function TailwindExpertTopNav({ screenWidth, headingIcon, headingTitle, setShowSideBar }) {
	const { logout, userData } = useAuth();
	const isDropzOpsUser = Boolean(userData?.isDropzOpsUser);
	const picture = userData?.picture || "";
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<div className="rounded-t-2xl border-b border-gray-200 flex items-center justify-between p-4 bg-white w-full h-14">
			{screenWidth <= 768 && (
				<i className="bi bi-list cursor-pointer text-gray-600 text-xl" onClick={() => setShowSideBar(true)} />
			)}
			{screenWidth > 768 && (
				<div className="flex items-center">
					{headingIcon && <i className={`bi bi-${headingIcon} text-gray-700 mr-2 text-xl`} />}
					{headingTitle && <div className="text-black text-base font-medium">{headingTitle}</div>}
				</div>
			)}

			<div className="flex items-center justify-end space-x-2 w-2/3 md:w-1/6">
				<div className="relative" ref={dropdownRef}>
					<div className="flex items-center space-x-2 cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
						{/* Hamburger Icon */}
						<div className="w-4 h-4 flex flex-col justify-between">
							<span className="w-full h-0.5 bg-gray-800 rounded-full" />
							<span className="w-full h-0.5 bg-gray-800 rounded-full" />
							<span className="w-full h-0.5 bg-gray-800 rounded-full" />
						</div>
						{/* Profile Image */}
						<div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
							<img src={picture} alt="User profile" width={32} height={32} className="rounded-full object-cover" />
						</div>
					</div>

					{/* Dropdown menu */}
					{isOpen && (
						<div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
							<Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
								Smart Profile
							</Link>
							<Link to="/my-resumes" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
								My Resumes
							</Link>
							<Link to="/jobs" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
								Jobs
							</Link>
							<Link to="/settings" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
								Settings
							</Link>
							{isDropzOpsUser && (
								<>
									<Link to="/job-market" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
										Control Center
									</Link>
									<Link to="/media-kit" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
										Media Kit
									</Link>
								</>
							)}
							<Link
								onClick={() => {
									logout();
									window.location.href = "/";
								}}
								className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
							>
								Logout
							</Link>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default TailwindExpertTopNav;
